<template>
    <div class="relative overflow-hidden bg-primary-bg

                " id="property-search">
        <div class="mb-16 tablet-sm:mb-20
                    mt-16
                    px-1 table-sm:px-0
                    mx-auto w-full flex items-center
                    max-w-76 mobile-lg:max-w-xs mobile-xl:max-w-lg tablet-sm:max-w-2xl tablet-lg:max-w-4xl laptop-lg:max-w-6xl desktop:max-w-7xl
                    desktop:max-w-screen-xl ultra-wide:max-w-screen-2xl
                   ">
            <div class="w-full">

                <div class="w-full pb-8" ref="flexIframeContainer" >
                    <div
                        id="home-search"
                        class="border-x-4 border-accent rounded-xl items-center rounded-sm px-3 py-2 flex flex-col"
                    >
                        <!-- Nested flex container for icon and h2 -->
                        <div class="flex items-center">
                            <MagnifyingGlassIcon class="relative w-10 h-10 mr-3 top-0.5" />
                            <h2
                                class="ml-0 text-2xl tablet-sm:text-4xl font-semibold text-primary-text shadow-sm font-subtitle">
                                Search Homes for Sale in Julington Creek, Nocatee, Ponte Vedra & More
                            </h2>
                        </div>
                        <!-- p tag on its own line -->
                        <p class="mt-2 ml-4 tablet-sm:mx-4 text-base tablet-sm:text-lg">
                            Use the home search tool to explore real-time listings across Julington Creek, Silverleaf,
                            Rivertown, and other top neighborhoods.
                        </p>
                    </div>
                </div>
                <div v-if="!isflexIframeVisible" class="absolute inset-0 flex items-center justify-center text-gray-500">
                    <h3>Loading search...</h3>
                </div>
                <div class="w-full tablet-sm:shadow-xl border-accent border-4 border-double min-h-property-search">
                    <iframe
                        v-if="isflexIframeVisible"
                        src='//link.flexmls.com/1wjm8v24kybz,15'
                        frameborder="0"
                        width="100%"
                        height="850"
                    ></iframe>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { MagnifyingGlassIcon } from "@heroicons/vue/24/solid";

import { onMounted, onUnmounted, ref } from "vue";

const memoryOptions = [
    { name: "Map", inStock: true },
    { name: "List", inStock: true },
];

const mem = ref(memoryOptions[1]); // Default to the third option
const isflexIframeVisible = ref(false);
const flexIframeContainer = ref(null);

let observer;
onMounted(() => {
    // Check if the user has already scrolled past the component
    const checkIfScrolledPast = () => {
        if (flexIframeContainer.value) {
            const rect = flexIframeContainer.value.getBoundingClientRect();
            return rect.top < 0; // True if the element is above the viewport
        }
        return false;
    };

    // If the user has already scrolled past the component, load it immediately
    if (checkIfScrolledPast()) {
        isflexIframeVisible.value = true;
    } else {
        // Otherwise, set up the IntersectionObserver to load when the component comes into view
        observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    isflexIframeVisible.value = true;
                    observer.disconnect(); // No need to observe anymore
                }
            },
            { threshold: 0.1 } // Trigger when 10% of the element is visible
        );

        if (flexIframeContainer.value) {
            observer.observe(flexIframeContainer.value);
        }
    }
});

onUnmounted(() => {
    if (observer) {
        observer.disconnect();
    }
});
</script>
